export default __webpack_public_path__ + "static/media/006-cement truck.c99eb074.svg";